@if (sharingContext.page) {
    <div class="context-heading">
        Link zur Buchseite {{ sharingContext.page.index | realPageNumber }}
    </div>
}

<ul>
    <li>
        <div (click)="copyLinkToClipboard()"
             (keydown.enter)="copyLinkToClipboard()"
             (keydown.space)="$event.preventDefault(); copyLinkToClipboard()"
             tabindex="0"
             role="button"
             class="sharing-option"
        >
            <div><img [src]="'sharing/share-link.png' | asset" alt="Link kopieren"></div>
            <span>Link kopieren</span>
        </div>
    </li>
    <li>
        <div (click)="openURL(emailLink)"
             (keydown.enter)="openURL(emailLink)"
             (keydown.space)="$event.preventDefault(); openURL(emailLink)"
             tabindex="0"
             role="button"
             class="sharing-option"
        >
            <div><img [src]="'sharing/share-email.png' | asset" alt="E-Mail senden"></div>
            <span>E-Mail senden</span>
        </div>
    </li>
    @if (schoolClassService.hasClassesForNotification()) {
        <li>
            <div (click)="classSharingModal()"
                 (keydown.enter)="classSharingModal()"
                 (keydown.space)="$event.preventDefault(); classSharingModal()"
                 tabindex="0"
                 role="button"
                 class="sharing-option"
            >
                <div><img [src]="'sharing/share-class.png' | asset" alt="Klasse informieren"></div>
                <span> Klasse informieren</span>
            </div>
        </li>
    }
    <li>
        <div (click)="copyLinkToClipboard('eduvidual')"
             (keydown.enter)="copyLinkToClipboard('eduvidual')"
             (keydown.space)="$event.preventDefault(); copyLinkToClipboard('eduvidual')"
             tabindex="0"
             role="button"
             class="sharing-option"
        >
            <div><img [src]="'sharing/share-eduvidual.png' | asset" alt="Link auf Eduvidual einfügen"></div>
            <span>Moodle / Eduvidual</span>
        </div>
    </li>
    <li>
        <div (click)="openURL(msTeamsLink)"
             (keydown.enter)="openURL(msTeamsLink)"
             (keydown.space)="$event.preventDefault(); openURL(msTeamsLink)"
             tabindex="0"
             role="button"
             class="sharing-option"
        >
            <div><img [src]="'sharing/share-microsoft.png' | asset" alt="Über MS Teams teilen"></div>
            <span>Microsoft Teams</span>
        </div>
    </li>
</ul>
